import * as React from 'react'

function PlayIcon(props) {
    return (
        <svg width={14} height={17} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M.4 8.652V1.675A1 1 0 011.938.832l10.94 6.976a1 1 0 010 1.687L1.938 16.47A1 1 0 01.4 15.628V8.652z" fill="#FFFFFF" stroke="white" />
        </svg>
    )
}

export default PlayIcon
